import { render, staticRenderFns } from "./UserActivityItem.vue?vue&type=template&id=f91f76bc&scoped=true"
import script from "./UserActivityItem.vue?vue&type=script&lang=js"
export * from "./UserActivityItem.vue?vue&type=script&lang=js"
import style0 from "./UserActivityItem.vue?vue&type=style&index=0&id=f91f76bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91f76bc",
  null
  
)

export default component.exports